import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "paper-plane",
  "use": "paper-plane-usage",
  "viewBox": "0 0 799.2 622",
  "content": "<symbol viewBox=\"0 0 799.2 622\" id=\"paper-plane\"><path d=\"M795.6 5.7c4 5.1 4.8 11.5 2.1 17.2L630.4 374.5c-2 4.4-6 7.4-10.8 8.6-2.5.6-5.4.5-8-.2-1.9-.6-3.7-1.6-5.4-2.9l-111.9-88-94.1 58c-3.8 2.5-8.4 3-12.7 1.8-1.9-.6-3.8-1.3-5.3-2.5-5.3-4.1-7.5-11-5.7-17.2l31.1-108.6-100.1-78.9c-4.9-3.7-7.1-9.8-5.8-16 1.2-5.9 5.9-10.5 11.8-12l466-116c5.9-1.7 12.3.4 16.1 5.1zM610.2 342.4L754.4 39.7l-401.6 99.9 71.3 56.1 251.4-94.1-169.7 158.6 104.4 82.2zM226.5 209.6L13 262.8c-5.6 1.4-11.3-2-12.7-7.6-1.4-5.6 2-11.3 7.6-12.7l213.5-53.2c5.6-1.4 11.3 2 12.7 7.6 1.4 5.5-2 11.3-7.6 12.7zM266.8 315.3L78.2 428.6c-4.9 3-11.4 1.4-14.4-3.6-3-4.9-1.4-11.4 3.6-14.4L256 297.3c4.9-3 11.4-1.4 14.4 3.6 2.9 4.8 1.4 11.4-3.6 14.4zM522.2 416.6l-93 199.4c-2.4 5.2-8.7 7.5-14 5.1-5.2-2.4-7.5-8.7-5.1-14l93-199.4c2.4-5.2 8.7-7.5 14-5.1 5.2 2.5 7.5 8.7 5.1 14zM370.4 409.4l-150 160.9c-3.9 4.2-10.6 4.5-14.8.5-4.2-3.9-4.5-10.6-.5-14.8l150-160.9c3.9-4.2 10.6-4.5 14.8-.5 4.2 3.9 4.4 10.6.5 14.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/paper-plane.svg
// module id = VSIF
// module chunks = 1